import { createRoot } from "react-dom/client";
import App from "./App";
import { Toaster } from "react-hot-toast";
import "./index.css";
import ErrorBoundary from "./components/ErrorBoundary/ErrorBoundary";
import store from "./store/store";
import { Provider } from "react-redux";

const rootElement = document.getElementById("root") as HTMLElement;
createRoot(rootElement).render(
  <ErrorBoundary>
    <Toaster
      position="top-right"
      reverseOrder={false}
      toastOptions={{
        style: {
          fontSize: "14px",
        },
      }}
    />
    <Provider store={store}>
      <App />
    </Provider>
  </ErrorBoundary>
);
